import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import {
	ALL_AGENTS_CATEGORY_ID,
	STARRED_AGENTS_CATEGORY_ID,
	VERIFIED_AGENTS_CATEGORY_ID,
	YOUR_AGENTS_CATEGORY_ID,
} from '../../categoryIds';
import type { CategoryEntryPointParams } from '../../types';
// oxlint-disable-next-line eslint-plugin-import(extensions) -- Relay generated artifacts must keep the .graphql extension to resolve.
import DefaultAgentResultsQuery from './__generated__/DefaultAgentResultsQuery.graphql';
// oxlint-disable-next-line eslint-plugin-import(extensions) -- Relay generated artifacts must keep the .graphql extension to resolve.
import DefaultAgentResultsRovoQuery from './__generated__/DefaultAgentResultsRovoQuery.graphql';
import type {
	AgentStudioQueryInput,
	DefaultAgentResultsExtraProps,
	DefaultAgentResultsQueries,
	DefaultAgentResultsRuntimeProps,
} from './types';

const PAGE_SIZE = 24;

export const AGENT_RESULTS_CONNECTION_KEY = 'DefaultAgentResults_browseAgentResults';

export const STARRED_AGENTS_FILTER: AgentStudioQueryInput = { onlyFavouriteAgents: true };
export const VERIFIED_AGENTS_FILTER: AgentStudioQueryInput = { onlyVerifiedAgents: true };

const CATEGORY_FILTERS: Record<string, AgentStudioQueryInput> = {
	[STARRED_AGENTS_CATEGORY_ID]: STARRED_AGENTS_FILTER,
	[YOUR_AGENTS_CATEGORY_ID]: { onlyMyAgents: true },
	[VERIFIED_AGENTS_CATEGORY_ID]: VERIFIED_AGENTS_FILTER,
};

type DefaultAgentResultsEntryPointComponent = EntryPointComponent<
	DefaultAgentResultsQueries,
	Record<string, never>,
	DefaultAgentResultsRuntimeProps,
	DefaultAgentResultsExtraProps
>;

export const defaultAgentResultsEntryPoint: EntryPoint<
	DefaultAgentResultsEntryPointComponent,
	CategoryEntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<DefaultAgentResultsEntryPointComponent>(() => import(/* webpackChunkName: "@atlaskit-internal_studio-browse-kit_default-agent-results" */ "./DefaultAgentResults"), { moduleId: "c8053706", moduleName: "DefaultAgentResults", modulePath: "../platform/packages/ai-mate/studio-agent-browse/src/ui/browse-agent/entrypoints/default/DefaultAgentResults.tsx", priority: "interaction", moduleId: 'studio-browse-kit_default-agent-results',
		}),
	getPreloadProps: ({
		categoryId,
		cloudId,
		product,
		searchValue = '',
		fetchPolicy = 'store-or-network',
	}) => {
		const includeRovo =
			categoryId === ALL_AGENTS_CATEGORY_ID &&
			!searchValue.trim() &&
			fg('rovo_agents_studio_browse_kit_cosmos');

		return {
			queries: {
				agentsQuery: {
					parameters: DefaultAgentResultsQuery,
					variables: {
						cloudId,
						first: PAGE_SIZE,
						input: CATEGORY_FILTERS[categoryId] ?? {},
						product,
						isJira: true,
					},
					options: { fetchPolicy },
				},
				rovoQuery: {
					parameters: DefaultAgentResultsRovoQuery,
					variables: { cloudId, product, includeRovo },
					// With no selected fields Relay can satisfy this query from the store.
					options: { fetchPolicy: includeRovo ? fetchPolicy : 'store-or-network' },
				},
			},
			extraProps: { product },
		};
	},
});
